// angular import
import { Component, Input } from '@angular/core';
import { NavigationItem } from '../../../layout/admin/navigation/navigation';
import { NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  // public props
  @Input() type: string;
  navigation;
  breadcrumbList = [];
  navigationList;

  // constructor
  constructor(private _router: Router, public nav: NavigationItem, private titleService: Title) {
    this.navigation = this.nav.get();
    this.setBreadcrumb();
    this.type = 'theme2';
  }

  // public method
  setBreadcrumb() {
    let routerUrl: string;
    this._router.events.subscribe((router: NavigationEnd) => {
      routerUrl = router.urlAfterRedirects;
      if (routerUrl && typeof routerUrl === 'string') {
        this.breadcrumbList.length = 0;
        const activeLink = router.url;
        this.filterNavigation(activeLink);
      }
    });
  }

  filterNavigation(activeLink) {
    debugger;
    let result: object;
    let title = 'Welcome';
    this.navigation.forEach(function (a) {
      if (a.type === 'item' && 'url' in a && a.url === activeLink) {
        result = [
          {
            url: 'url' in a ? a.url : false,
            title: a.title,
            breadcrumbs: 'breadcrumbs' in a ? a.breadcrumbs : true,
            type: a.type
          }
        ];
        title = a.title;
      } else {
        if (a.type === 'group' && 'children' in a) {
          if (a.children)
            a.children.forEach(function (b) {
              if (b.type === 'collapse' && 'children' in b) {
                if (b.children)
                  b.children.forEach(function (bb) {
                    if (bb.type === 'item' && bb.url == activeLink) {
                      result = [
                        {
                          url: 'url' in bb ? bb.url : false,
                          title: bb.title,
                          breadcrumbs: 'breadcrumbs' in bb ? bb.breadcrumbs : true,
                          type: bb.type
                        }
                      ];
                      title = bb.title;
                    }
                    else if (bb.type === 'collapse' && bb.id == 'notes') {
                      if (bb.children)
                        bb.children.forEach(function (dd) {

                          if (dd.type === 'item' && dd.url == '.'+activeLink) {
                            result = [
                              {
                                url: 'url' in dd ? dd.url : false,
                                title: dd.title,
                                breadcrumbs: 'breadcrumbs' in dd ? bb.breadcrumbs : true,
                                type: dd.type
                              }
                            ];
                            title = bb.title;
                          }
                        })
                     
                    }
                  })
              } else {
                if (b.type === 'item' && 'children' in b) {
                  b.children.forEach(function (c) {
                    if (c.type === 'item' && 'url' in c && c.url === activeLink) {
                      result = [
                        {
                          url: 'url' in b ? b.url : false,
                          title: b.title,
                          breadcrumbs: 'breadcrumbs' in b ? b.breadcrumbs : true,
                          type: b.type
                        },
                        {
                          url: 'url' in c ? c.url : false,
                          title: c.title,
                          breadcrumbs: 'breadcrumbs' in c ? c.breadcrumbs : true,
                          type: c.type
                        }
                      ];
                      title = c.title;
                    }
                  });
                }
              }
            });
        }
      }
    });
    this.navigationList = result;
    /*this.titleService.setTitle(title + ' | Datta Able Angular Template');*/
    this.titleService.setTitle('Andica Accounts Production');
  }
}
